(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('HelperService', HelperService)

    /** @ngInject */
    function HelperService($timeout, $state, $rootScope, $q, sweetAlert, ValidationMessageService, NotifyService, AuthenticationService,
        AUTH_EVENTS, ROUTES, LOCAL_STORAGE_ITEMS) {
        const HelperService = {
            tryParseJSON: tryParseJSON,
            handleOnRun: handleOnRun,
            handleLocationChangeStart: handleLocationChangeStart,
            handleStateChangeStart: handleStateChangeStart,
            handleStateChangeSuccess: handleStateChangeSuccess,
            handleStateChangeError: handleStateChangeError,
            handleViewContentLoaded: handleViewContentLoaded,
            errorCallback: errorCallback,
            successCallback: successCallback,
            startLoading: startLoading,
            stopLoading: stopLoading,
            setErrorMessageForm: setErrorMessageForm,
            removeErrorMessageForm: removeErrorMessageForm,
            isScreenSmaller: isScreenSmaller,
            getFlowOptionsDefaultsFile: getFlowOptionsDefaultsFile,
            fileFolderPath: fileFolderPath,
            fileHandlerPath: fileHandlerPath,
            imageFolderPath: imageFolderPath,
            imageHandlerPath: imageHandlerPath,
            imageResizePath: imageResizePath,
            imageHandlerFileIcon: imageHandlerFileIcon,
            uiCanExit: uiCanExit
        };

        return HelperService;

        function getFlowOptionsDefaultsFile() {
            const token = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            let headers = {};

            if (token)
                headers['Authorization'] = 'Bearer ' + token;

            return {
                permanentErrors: [500, 501, 428],
                maxChunkRetries: 1,
                chunkRetryInterval: 5000,
                allowDuplicateUploads: true,
                simultaneousUploads: 5,
                target: `${ROUTES.API}/upload-files`,
                headers: headers
            }
        }

        function fileFolderPath(area, file) {
            return `${ROUTES.API}/Assets/Uploads/${area}/${file}`;
        }

        function imageFolderPath(area, id, file) {
            return `${ROUTES.API}/Assets/Uploads/${area}/${id}/${file}`;
        }

        function fileHandlerPath(area, file) {
            return `${ROUTES.API}/files/res/${area}/${file}`;
        }

        function imageHandlerPath(area, id, file) {
            return `${ROUTES.API}/images/res/${area}/${id}/${file}`;
        }

        function imageResizePath(area, id, file, width, height) {
            return `${ROUTES.API}/images/res/${width}/${height}/${area}/${id}/${file}`;
        }

        function imageHandlerFileIcon(fileExtension) {
            const availableExtensions = [
                'csv',
                'doc',
                'docx',
                'gif',
                'jpeg',
                'jpg',
                'pdf',
                'png',
                'ppt',
                'pptx',
                'rar',
                'txt',
                'xls',
                'xlsx',
                'zip',
                'mp3',
                'mp4'
            ];

            if (availableExtensions.includes(fileExtension.trim()))
                return `${ROUTES.APP}/app/dist/images/file-icons/${fileExtension}.png`;

            return `${ROUTES.APP}/app/dist/images/file-icons/generic.png`;
        }

        function uiCanExit(originalData, compareData) {
            let defer = $q.defer();

            let showModal = () => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Você irá perder as alterações que executou',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value)
                        defer.resolve(true);
                    else
                        defer.resolve(false);
                })
            }

            if (originalData && originalData.constructor === Array && compareData && compareData.constructor === Array) {
                let hasDiff = false;

                for (let index = 0; index < originalData.length; index++) {
                    const data = originalData[index];

                    if (compareData[index] && !angular.equals(data, compareData[index])) {
                        hasDiff = true;
                        showModal();
                    }
                }

                if (!hasDiff)
                    defer.resolve(true);
            } else {
                if (!angular.equals(originalData, compareData))
                    showModal();
                else
                    defer.resolve(true);
            }

            return defer.promise;
        }

        /**
         * Tries to parse a JSON string
         * 
         * @param {string} jsonString - String to be parsed
         */
        function tryParseJSON(jsonString) {
            try {
                var o = JSON.parse(jsonString);

                // Handle non-exception-throwing cases:
                // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
                // but... JSON.parse(null) returns null, and typeof null === "object",
                // so we must check for that, too. Thankfully, null is falsey, so this suffices:
                if (o && typeof o === 'object')
                    return o;
            } catch (e) {
                return false;
            }

            return false;
        }

        /**
         * Auxiliar method to prevent state and location change if there's a sweet alert modal open
         * 
         * @param {object} event - The current event
         */
        function handleLocationChangeStart(event) {
            if ($rootScope.isSweetAlertModalOpen)
                event.preventDefault();
        }

        /**
         * Auxiliar method to execute the necessary methods on the route change start
         * 
         * @param {object} transition - The executing transition
         */
        function handleStateChangeStart(transition) {
            $rootScope.alignLayoutCenter = false;
            $rootScope.fullScreenApp = false;
            $rootScope.showNotifications = false;
            $rootScope.showSearch = false;

            const nextUrl = transition.to().url;

            if (transition.to().name.indexOf('app-auth') >= 0)
                return transition;

            if (nextUrl.indexOf('not-authorized') >= 0 && AuthenticationService.isLogged())
                return transition;

            if (!AuthenticationService.isLogged()) {
                AuthenticationService.logout();
                return false;
            }

            if (isScreenSmaller(991) && $('body').hasClass('menu-fixed'))
                $rootScope.menuOpen = false;

            return transition;
        }

        /**
         * Auxiliar method executed on every route state successfull change
         */
        function handleStateChangeSuccess() {
            $('.modal-backdrop').remove();

            document.body.scrollTop = document.documentElement.scrollTop = 0;

            setAffixOnScroll();
        }

        /**
         * Auxiliar method executed once the system has finished loading all of it's content
         */
        function handleViewContentLoaded() {

        }

        /**
         * Auxiliar method executed when the system is starting
         */
        function handleOnRun() {
            //Comment this to exit errors related to transition and/or transition related services like User or Menu
            // $state.defaultErrorHandler(angular.noop);

            $rootScope.isSweetAlertModalOpen = false;
            $rootScope.removeMessage = removeErrorMessageForm;

            $rootScope.isMobile = isScreenSmaller(991);

            $rootScope.currentYear = moment().format('YYYY');

            $rootScope.validationMessage = ValidationMessageService.getMessage;

            $rootScope.$on(AUTH_EVENTS.NOT_AUTHENTICATED, () => AuthenticationService.logout());

            $rootScope.canUserView = true;
            $rootScope.canUserEdit = true;
            $rootScope.canUserDelete = true;
        }

        /**
         * Auxiliar method executed when the route change fails
         *
         * @param {object} error - The transition error
         */
        function handleStateChangeError(error) {
            console.log('error: ', error);
            console.log('$state.current: ', $state.current);
            if (error && error.redirTo)
                $state.go(error.redirTo);
        }

        function isScreenSmaller(size) {
            return Modernizr.mq(`(max-width: ${size}px)`);
        }

        function errorCallback(error) {
            let message = 'Ocorreu um erro inesperado, por favor tente novamente!';

            if (error && error.data && error.data.ErrorCode) {
                if (error.data.ErrorCode == 404 || error.data.ErrorCode == 409)
                    message = error.data.ErrorMessage || 'Ocorreu um erro inesperado, por favor tente novamente!';

                else if (error.data.ErrorCode == 422) {
                    const errorMessage = error.data.ErrorMessage;
                    let parsedErrorMessage;

                    if (typeof errorMessage === 'string')
                        parsedErrorMessage = tryParseJSON(errorMessage);

                    if (typeof parsedErrorMessage === typeof []) {
                        let messages = parsedErrorMessage;
                        message = '';

                        if (messages) {
                            for (let i = 0; i < messages.length; i++)
                                message += messages[i].ErrorMessage;
                        }
                    } else
                        message = errorMessage;
                }
            } else if (error && error.data && error.data.error && error.data.error_description) {
                if (error.data.error == 'invalid_grant')
                    message = error.data.error_description;
            }

            NotifyService.error(message);
        }

        function successCallback(type = 'create') {
            let message = '';

            if (type == 'create')
                message = 'Registro salvo com sucesso';

            else if (type == 'update')
                message = 'Registro atualizado com sucesso';

            else if (type == 'delete')
                message = 'Registro apagado com sucesso';

            NotifyService.success(message);
        }

        function startLoading(element, smaller = false) {
            $timeout(() => {
                let widget = $(element).closest('[data-widget]');
                let smallerClass = '';

                if ($(element).attr('[data-widget]'))
                    widget = $(element);

                if (smaller)
                    smallerClass = 'smaller';

                widget.append(`<div class="loading-body ${smallerClass}">
                                <img src="/app/dist/images/progress-circle-complete.svg" alt="Carregando, aguarde...">
                            </div>`);
            })
        }

        function stopLoading(element) {
            $timeout(() => {
                let widget = $(element).closest('[data-widget]');

                if ($(element).attr('[data-widget]'))
                    widget = $(element);

                widget
                    .find('.loading-body')
                    .fadeOut(function () {
                        $(this).remove();
                    });
            })
        }

        function setErrorMessageForm(input, message) {
            let errorMessage = 'Este campo é obrigatório';

            if (message)
                errorMessage = message;

            if (!$(input).parent().find('.validationMessage').length) {
                $(input).parent()
                    .append(`<label class=\'control-label has-error validationMessage\'>${errorMessage}</label>`);

                $(input)
                    .addClass('has-error')
                    .parents('.form-group')
                    .addClass('has-error');
            }

            $([document.documentElement, document.body]).animate({
                scrollTop: $(input).offset().top - ($('.header').outerHeight() + 30)
            }, 600);
        }

        function removeErrorMessageForm(input) {
            $(input)
                .parent()
                .find('.validationMessage')
                .remove();

            $(input)
                .removeClass('has-error')
                .parents('.form-group')
                .removeClass('has-error');
        }

        function setAffixOnScroll() {
            var toggleAffix = function (affixElement, scrollElement, wrapper) {
                var height = affixElement.outerHeight(),
                    top = wrapper.offset().top,
                    offset = affixElement.attr('offset') || 0;

                if (scrollElement.scrollTop() >= (top - offset)) {
                    wrapper.height(height);
                    affixElement.addClass("affix");
                } else {
                    affixElement.removeClass("affix");
                    wrapper.height('auto');
                }
            }


            $('[data-toggle="affix"]').each(function () {
                var ele = $(this),
                    wrapper = $('<div></div>');

                ele.before(wrapper);

                $(window).on('scroll resize', function () {
                    toggleAffix(ele, $(this), wrapper);
                });

                // init
                toggleAffix(ele, $(window), wrapper);
            });
        }
    }
}());